function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var parcelRequire = $parcel$global["parcelRequire02ae"];
parcelRequire.register("lUOEJ", function(module, exports) {

$parcel$export(module.exports, "WalletConnectModal", () => $ff461f234bab4cda$export$642f71372fab1590);

var $hohVq = parcelRequire("hohVq");

class $ff461f234bab4cda$export$642f71372fab1590 {
    constructor(e){
        this.openModal = (0, $hohVq.ModalCtrl).open, this.closeModal = (0, $hohVq.ModalCtrl).close, this.subscribeModal = (0, $hohVq.ModalCtrl).subscribe, this.setTheme = (0, $hohVq.ThemeCtrl).setThemeConfig, (0, $hohVq.ThemeCtrl).setThemeConfig(e), (0, $hohVq.ConfigCtrl).setConfig(e), this.initUi();
    }
    async initUi() {
        if (typeof window < "u") {
            await (parcelRequire("aIeTu"));
            const e = document.createElement("wcm-modal");
            document.body.insertAdjacentElement("beforeend", e), (0, $hohVq.OptionsCtrl).setIsUiLoaded(!0);
        }
    }
}

});
parcelRequire.register("hohVq", function(module, exports) {

$parcel$export(module.exports, "RouterCtrl", () => $ca92951fe17fd102$export$2dd8023fb2cd44c);
$parcel$export(module.exports, "CoreUtil", () => $ca92951fe17fd102$export$2ff3ceb398d6f444);
$parcel$export(module.exports, "EventsCtrl", () => $ca92951fe17fd102$export$59a837b99037295);
$parcel$export(module.exports, "OptionsCtrl", () => $ca92951fe17fd102$export$5f7b08e38aeeee56);
$parcel$export(module.exports, "ConfigCtrl", () => $ca92951fe17fd102$export$5239b2e4de4e2646);
$parcel$export(module.exports, "ExplorerCtrl", () => $ca92951fe17fd102$export$8a0e3ad54b37ee57);
$parcel$export(module.exports, "ModalCtrl", () => $ca92951fe17fd102$export$f6ef1648e6110c37);
$parcel$export(module.exports, "ThemeCtrl", () => $ca92951fe17fd102$export$fed0363cf09933ba);
$parcel$export(module.exports, "ToastCtrl", () => $ca92951fe17fd102$export$49bec3d5b199c07);

var $lDt57 = parcelRequire("lDt57");
const $ca92951fe17fd102$var$o = (0, $lDt57.proxy)({
    history: [
        "ConnectWallet"
    ],
    view: "ConnectWallet",
    data: void 0
}), $ca92951fe17fd102$export$2dd8023fb2cd44c = {
    state: $ca92951fe17fd102$var$o,
    subscribe (e) {
        return (0, $lDt57.subscribe)($ca92951fe17fd102$var$o, ()=>e($ca92951fe17fd102$var$o));
    },
    push (e, t) {
        e !== $ca92951fe17fd102$var$o.view && ($ca92951fe17fd102$var$o.view = e, t && ($ca92951fe17fd102$var$o.data = t), $ca92951fe17fd102$var$o.history.push(e));
    },
    reset (e) {
        $ca92951fe17fd102$var$o.view = e, $ca92951fe17fd102$var$o.history = [
            e
        ];
    },
    replace (e) {
        $ca92951fe17fd102$var$o.history.length > 1 && ($ca92951fe17fd102$var$o.history[$ca92951fe17fd102$var$o.history.length - 1] = e, $ca92951fe17fd102$var$o.view = e);
    },
    goBack () {
        if ($ca92951fe17fd102$var$o.history.length > 1) {
            $ca92951fe17fd102$var$o.history.pop();
            const [e] = $ca92951fe17fd102$var$o.history.slice(-1);
            $ca92951fe17fd102$var$o.view = e;
        }
    },
    setData (e) {
        $ca92951fe17fd102$var$o.data = e;
    }
}, $ca92951fe17fd102$export$2ff3ceb398d6f444 = {
    WALLETCONNECT_DEEPLINK_CHOICE: "WALLETCONNECT_DEEPLINK_CHOICE",
    WCM_VERSION: "WCM_VERSION",
    RECOMMENDED_WALLET_AMOUNT: 9,
    isMobile () {
        return typeof window < "u" ? Boolean(window.matchMedia("(pointer:coarse)").matches || /Android|webOS|iPhone|iPad|iPod|BlackBerry|Opera Mini/u.test(navigator.userAgent)) : !1;
    },
    isAndroid () {
        return $ca92951fe17fd102$export$2ff3ceb398d6f444.isMobile() && navigator.userAgent.toLowerCase().includes("android");
    },
    isIos () {
        const e = navigator.userAgent.toLowerCase();
        return $ca92951fe17fd102$export$2ff3ceb398d6f444.isMobile() && (e.includes("iphone") || e.includes("ipad"));
    },
    isHttpUrl (e) {
        return e.startsWith("http://") || e.startsWith("https://");
    },
    isArray (e) {
        return Array.isArray(e) && e.length > 0;
    },
    formatNativeUrl (e, t, s) {
        if ($ca92951fe17fd102$export$2ff3ceb398d6f444.isHttpUrl(e)) return this.formatUniversalUrl(e, t, s);
        let n = e;
        n.includes("://") || (n = e.replaceAll("/", "").replaceAll(":", ""), n = `${n}://`), n.endsWith("/") || (n = `${n}/`), this.setWalletConnectDeepLink(n, s);
        const i = encodeURIComponent(t);
        return `${n}wc?uri=${i}`;
    },
    formatUniversalUrl (e, t, s) {
        if (!$ca92951fe17fd102$export$2ff3ceb398d6f444.isHttpUrl(e)) return this.formatNativeUrl(e, t, s);
        let n = e;
        n.endsWith("/") || (n = `${n}/`), this.setWalletConnectDeepLink(n, s);
        const i = encodeURIComponent(t);
        return `${n}wc?uri=${i}`;
    },
    async wait (e) {
        return new Promise((t)=>{
            setTimeout(t, e);
        });
    },
    openHref (e, t) {
        window.open(e, t, "noreferrer noopener");
    },
    setWalletConnectDeepLink (e, t) {
        try {
            localStorage.setItem($ca92951fe17fd102$export$2ff3ceb398d6f444.WALLETCONNECT_DEEPLINK_CHOICE, JSON.stringify({
                href: e,
                name: t
            }));
        } catch  {
            console.info("Unable to set WalletConnect deep link");
        }
    },
    setWalletConnectAndroidDeepLink (e) {
        try {
            const [t] = e.split("?");
            localStorage.setItem($ca92951fe17fd102$export$2ff3ceb398d6f444.WALLETCONNECT_DEEPLINK_CHOICE, JSON.stringify({
                href: t,
                name: "Android"
            }));
        } catch  {
            console.info("Unable to set WalletConnect android deep link");
        }
    },
    removeWalletConnectDeepLink () {
        try {
            localStorage.removeItem($ca92951fe17fd102$export$2ff3ceb398d6f444.WALLETCONNECT_DEEPLINK_CHOICE);
        } catch  {
            console.info("Unable to remove WalletConnect deep link");
        }
    },
    setModalVersionInStorage () {
        try {
            typeof localStorage < "u" && localStorage.setItem($ca92951fe17fd102$export$2ff3ceb398d6f444.WCM_VERSION, "2.6.2");
        } catch  {
            console.info("Unable to set Web3Modal version in storage");
        }
    },
    getWalletRouterData () {
        var e;
        const t = (e = $ca92951fe17fd102$export$2dd8023fb2cd44c.state.data) == null ? void 0 : e.Wallet;
        if (!t) throw new Error('Missing "Wallet" view data');
        return t;
    }
}, $ca92951fe17fd102$var$_ = typeof location < "u" && (location.hostname.includes("localhost") || location.protocol.includes("https")), $ca92951fe17fd102$var$r = (0, $lDt57.proxy)({
    enabled: $ca92951fe17fd102$var$_,
    userSessionId: "",
    events: [],
    connectedWalletId: void 0
}), $ca92951fe17fd102$export$59a837b99037295 = {
    state: $ca92951fe17fd102$var$r,
    subscribe (e) {
        return (0, $lDt57.subscribe)($ca92951fe17fd102$var$r.events, ()=>e((0, $lDt57.snapshot)($ca92951fe17fd102$var$r.events[$ca92951fe17fd102$var$r.events.length - 1])));
    },
    initialize () {
        $ca92951fe17fd102$var$r.enabled && typeof (crypto == null ? void 0 : crypto.randomUUID) < "u" && ($ca92951fe17fd102$var$r.userSessionId = crypto.randomUUID());
    },
    setConnectedWalletId (e) {
        $ca92951fe17fd102$var$r.connectedWalletId = e;
    },
    click (e) {
        if ($ca92951fe17fd102$var$r.enabled) {
            const t = {
                type: "CLICK",
                name: e.name,
                userSessionId: $ca92951fe17fd102$var$r.userSessionId,
                timestamp: Date.now(),
                data: e
            };
            $ca92951fe17fd102$var$r.events.push(t);
        }
    },
    track (e) {
        if ($ca92951fe17fd102$var$r.enabled) {
            const t = {
                type: "TRACK",
                name: e.name,
                userSessionId: $ca92951fe17fd102$var$r.userSessionId,
                timestamp: Date.now(),
                data: e
            };
            $ca92951fe17fd102$var$r.events.push(t);
        }
    },
    view (e) {
        if ($ca92951fe17fd102$var$r.enabled) {
            const t = {
                type: "VIEW",
                name: e.name,
                userSessionId: $ca92951fe17fd102$var$r.userSessionId,
                timestamp: Date.now(),
                data: e
            };
            $ca92951fe17fd102$var$r.events.push(t);
        }
    }
}, $ca92951fe17fd102$var$c = (0, $lDt57.proxy)({
    chains: void 0,
    walletConnectUri: void 0,
    isAuth: !1,
    isCustomDesktop: !1,
    isCustomMobile: !1,
    isDataLoaded: !1,
    isUiLoaded: !1
}), $ca92951fe17fd102$export$5f7b08e38aeeee56 = {
    state: $ca92951fe17fd102$var$c,
    subscribe (e) {
        return (0, $lDt57.subscribe)($ca92951fe17fd102$var$c, ()=>e($ca92951fe17fd102$var$c));
    },
    setChains (e) {
        $ca92951fe17fd102$var$c.chains = e;
    },
    setWalletConnectUri (e) {
        $ca92951fe17fd102$var$c.walletConnectUri = e;
    },
    setIsCustomDesktop (e) {
        $ca92951fe17fd102$var$c.isCustomDesktop = e;
    },
    setIsCustomMobile (e) {
        $ca92951fe17fd102$var$c.isCustomMobile = e;
    },
    setIsDataLoaded (e) {
        $ca92951fe17fd102$var$c.isDataLoaded = e;
    },
    setIsUiLoaded (e) {
        $ca92951fe17fd102$var$c.isUiLoaded = e;
    },
    setIsAuth (e) {
        $ca92951fe17fd102$var$c.isAuth = e;
    }
}, $ca92951fe17fd102$var$W = (0, $lDt57.proxy)({
    projectId: "",
    mobileWallets: void 0,
    desktopWallets: void 0,
    walletImages: void 0,
    chains: void 0,
    enableAuthMode: !1,
    enableExplorer: !0,
    explorerExcludedWalletIds: void 0,
    explorerRecommendedWalletIds: void 0,
    termsOfServiceUrl: void 0,
    privacyPolicyUrl: void 0
}), $ca92951fe17fd102$export$5239b2e4de4e2646 = {
    state: $ca92951fe17fd102$var$W,
    subscribe (e) {
        return (0, $lDt57.subscribe)($ca92951fe17fd102$var$W, ()=>e($ca92951fe17fd102$var$W));
    },
    setConfig (e) {
        var t, s;
        $ca92951fe17fd102$export$59a837b99037295.initialize(), $ca92951fe17fd102$export$5f7b08e38aeeee56.setChains(e.chains), $ca92951fe17fd102$export$5f7b08e38aeeee56.setIsAuth(Boolean(e.enableAuthMode)), $ca92951fe17fd102$export$5f7b08e38aeeee56.setIsCustomMobile(Boolean((t = e.mobileWallets) == null ? void 0 : t.length)), $ca92951fe17fd102$export$5f7b08e38aeeee56.setIsCustomDesktop(Boolean((s = e.desktopWallets) == null ? void 0 : s.length)), $ca92951fe17fd102$export$2ff3ceb398d6f444.setModalVersionInStorage(), Object.assign($ca92951fe17fd102$var$W, e);
    }
};
var $ca92951fe17fd102$var$V = Object.defineProperty, $ca92951fe17fd102$var$D = Object.getOwnPropertySymbols, $ca92951fe17fd102$var$H = Object.prototype.hasOwnProperty, $ca92951fe17fd102$var$B = Object.prototype.propertyIsEnumerable, $ca92951fe17fd102$var$M = (e, t, s)=>t in e ? $ca92951fe17fd102$var$V(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : e[t] = s, $ca92951fe17fd102$var$K = (e, t)=>{
    for(var s in t || (t = {}))$ca92951fe17fd102$var$H.call(t, s) && $ca92951fe17fd102$var$M(e, s, t[s]);
    if ($ca92951fe17fd102$var$D) for (var s of $ca92951fe17fd102$var$D(t))$ca92951fe17fd102$var$B.call(t, s) && $ca92951fe17fd102$var$M(e, s, t[s]);
    return e;
};
const $ca92951fe17fd102$var$L = "https://explorer-api.walletconnect.com", $ca92951fe17fd102$var$E = "wcm", $ca92951fe17fd102$var$O = "js-2.6.2";
async function $ca92951fe17fd102$var$w(e, t) {
    const s = $ca92951fe17fd102$var$K({
        sdkType: $ca92951fe17fd102$var$E,
        sdkVersion: $ca92951fe17fd102$var$O
    }, t), n = new URL(e, $ca92951fe17fd102$var$L);
    return n.searchParams.append("projectId", $ca92951fe17fd102$export$5239b2e4de4e2646.state.projectId), Object.entries(s).forEach(([i, l])=>{
        l && n.searchParams.append(i, String(l));
    }), (await fetch(n)).json();
}
const $ca92951fe17fd102$var$m = {
    async getDesktopListings (e) {
        return $ca92951fe17fd102$var$w("/w3m/v1/getDesktopListings", e);
    },
    async getMobileListings (e) {
        return $ca92951fe17fd102$var$w("/w3m/v1/getMobileListings", e);
    },
    async getInjectedListings (e) {
        return $ca92951fe17fd102$var$w("/w3m/v1/getInjectedListings", e);
    },
    async getAllListings (e) {
        return $ca92951fe17fd102$var$w("/w3m/v1/getAllListings", e);
    },
    getWalletImageUrl (e) {
        return `${$ca92951fe17fd102$var$L}/w3m/v1/getWalletImage/${e}?projectId=${$ca92951fe17fd102$export$5239b2e4de4e2646.state.projectId}&sdkType=${$ca92951fe17fd102$var$E}&sdkVersion=${$ca92951fe17fd102$var$O}`;
    },
    getAssetImageUrl (e) {
        return `${$ca92951fe17fd102$var$L}/w3m/v1/getAssetImage/${e}?projectId=${$ca92951fe17fd102$export$5239b2e4de4e2646.state.projectId}&sdkType=${$ca92951fe17fd102$var$E}&sdkVersion=${$ca92951fe17fd102$var$O}`;
    }
};
var $ca92951fe17fd102$var$z = Object.defineProperty, $ca92951fe17fd102$var$j = Object.getOwnPropertySymbols, $ca92951fe17fd102$var$J = Object.prototype.hasOwnProperty, $ca92951fe17fd102$var$q = Object.prototype.propertyIsEnumerable, $ca92951fe17fd102$var$k = (e, t, s)=>t in e ? $ca92951fe17fd102$var$z(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : e[t] = s, $ca92951fe17fd102$var$F = (e, t)=>{
    for(var s in t || (t = {}))$ca92951fe17fd102$var$J.call(t, s) && $ca92951fe17fd102$var$k(e, s, t[s]);
    if ($ca92951fe17fd102$var$j) for (var s of $ca92951fe17fd102$var$j(t))$ca92951fe17fd102$var$q.call(t, s) && $ca92951fe17fd102$var$k(e, s, t[s]);
    return e;
};
const $ca92951fe17fd102$var$N = $ca92951fe17fd102$export$2ff3ceb398d6f444.isMobile(), $ca92951fe17fd102$var$d = (0, $lDt57.proxy)({
    wallets: {
        listings: [],
        total: 0,
        page: 1
    },
    search: {
        listings: [],
        total: 0,
        page: 1
    },
    recomendedWallets: []
}), $ca92951fe17fd102$export$8a0e3ad54b37ee57 = {
    state: $ca92951fe17fd102$var$d,
    async getRecomendedWallets () {
        const { explorerRecommendedWalletIds: e, explorerExcludedWalletIds: t } = $ca92951fe17fd102$export$5239b2e4de4e2646.state;
        if (e === "NONE" || t === "ALL" && !e) return $ca92951fe17fd102$var$d.recomendedWallets;
        if ($ca92951fe17fd102$export$2ff3ceb398d6f444.isArray(e)) {
            const s = {
                recommendedIds: e.join(",")
            }, { listings: n } = await $ca92951fe17fd102$var$m.getAllListings(s), i = Object.values(n);
            i.sort((l, v)=>{
                const b = e.indexOf(l.id), f = e.indexOf(v.id);
                return b - f;
            }), $ca92951fe17fd102$var$d.recomendedWallets = i;
        } else {
            const { chains: s, isAuth: n } = $ca92951fe17fd102$export$5f7b08e38aeeee56.state, i = s?.join(","), l = $ca92951fe17fd102$export$2ff3ceb398d6f444.isArray(t), v = {
                page: 1,
                sdks: n ? "auth_v1" : void 0,
                entries: $ca92951fe17fd102$export$2ff3ceb398d6f444.RECOMMENDED_WALLET_AMOUNT,
                chains: i,
                version: 2,
                excludedIds: l ? t.join(",") : void 0
            }, { listings: b } = $ca92951fe17fd102$var$N ? await $ca92951fe17fd102$var$m.getMobileListings(v) : await $ca92951fe17fd102$var$m.getDesktopListings(v);
            $ca92951fe17fd102$var$d.recomendedWallets = Object.values(b);
        }
        return $ca92951fe17fd102$var$d.recomendedWallets;
    },
    async getWallets (e) {
        const t = $ca92951fe17fd102$var$F({}, e), { explorerRecommendedWalletIds: s, explorerExcludedWalletIds: n } = $ca92951fe17fd102$export$5239b2e4de4e2646.state, { recomendedWallets: i } = $ca92951fe17fd102$var$d;
        if (n === "ALL") return $ca92951fe17fd102$var$d.wallets;
        i.length ? t.excludedIds = i.map((x)=>x.id).join(",") : $ca92951fe17fd102$export$2ff3ceb398d6f444.isArray(s) && (t.excludedIds = s.join(",")), $ca92951fe17fd102$export$2ff3ceb398d6f444.isArray(n) && (t.excludedIds = [
            t.excludedIds,
            n
        ].filter(Boolean).join(",")), $ca92951fe17fd102$export$5f7b08e38aeeee56.state.isAuth && (t.sdks = "auth_v1");
        const { page: l, search: v } = e, { listings: b, total: f } = $ca92951fe17fd102$var$N ? await $ca92951fe17fd102$var$m.getMobileListings(t) : await $ca92951fe17fd102$var$m.getDesktopListings(t), A = Object.values(b), U = v ? "search" : "wallets";
        return $ca92951fe17fd102$var$d[U] = {
            listings: [
                ...$ca92951fe17fd102$var$d[U].listings,
                ...A
            ],
            total: f,
            page: l ?? 1
        }, {
            listings: A,
            total: f
        };
    },
    getWalletImageUrl (e) {
        return $ca92951fe17fd102$var$m.getWalletImageUrl(e);
    },
    getAssetImageUrl (e) {
        return $ca92951fe17fd102$var$m.getAssetImageUrl(e);
    },
    resetSearch () {
        $ca92951fe17fd102$var$d.search = {
            listings: [],
            total: 0,
            page: 1
        };
    }
}, $ca92951fe17fd102$var$I = (0, $lDt57.proxy)({
    open: !1
}), $ca92951fe17fd102$export$f6ef1648e6110c37 = {
    state: $ca92951fe17fd102$var$I,
    subscribe (e) {
        return (0, $lDt57.subscribe)($ca92951fe17fd102$var$I, ()=>e($ca92951fe17fd102$var$I));
    },
    async open (e) {
        return new Promise((t)=>{
            const { isUiLoaded: s, isDataLoaded: n } = $ca92951fe17fd102$export$5f7b08e38aeeee56.state;
            if ($ca92951fe17fd102$export$2ff3ceb398d6f444.removeWalletConnectDeepLink(), $ca92951fe17fd102$export$5f7b08e38aeeee56.setWalletConnectUri(e?.uri), $ca92951fe17fd102$export$5f7b08e38aeeee56.setChains(e?.chains), $ca92951fe17fd102$export$2dd8023fb2cd44c.reset("ConnectWallet"), s && n) $ca92951fe17fd102$var$I.open = !0, t();
            else {
                const i = setInterval(()=>{
                    const l = $ca92951fe17fd102$export$5f7b08e38aeeee56.state;
                    l.isUiLoaded && l.isDataLoaded && (clearInterval(i), $ca92951fe17fd102$var$I.open = !0, t());
                }, 200);
            }
        });
    },
    close () {
        $ca92951fe17fd102$var$I.open = !1;
    }
};
var $ca92951fe17fd102$var$G = Object.defineProperty, $ca92951fe17fd102$var$$ = Object.getOwnPropertySymbols, $ca92951fe17fd102$var$Q = Object.prototype.hasOwnProperty, $ca92951fe17fd102$var$X = Object.prototype.propertyIsEnumerable, $ca92951fe17fd102$var$S = (e, t, s)=>t in e ? $ca92951fe17fd102$var$G(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: s
    }) : e[t] = s, $ca92951fe17fd102$var$Y = (e, t)=>{
    for(var s in t || (t = {}))$ca92951fe17fd102$var$Q.call(t, s) && $ca92951fe17fd102$var$S(e, s, t[s]);
    if ($ca92951fe17fd102$var$$) for (var s of $ca92951fe17fd102$var$$(t))$ca92951fe17fd102$var$X.call(t, s) && $ca92951fe17fd102$var$S(e, s, t[s]);
    return e;
};
function $ca92951fe17fd102$var$Z() {
    return typeof matchMedia < "u" && matchMedia("(prefers-color-scheme: dark)").matches;
}
const $ca92951fe17fd102$var$C = (0, $lDt57.proxy)({
    themeMode: $ca92951fe17fd102$var$Z() ? "dark" : "light"
}), $ca92951fe17fd102$export$fed0363cf09933ba = {
    state: $ca92951fe17fd102$var$C,
    subscribe (e) {
        return (0, $lDt57.subscribe)($ca92951fe17fd102$var$C, ()=>e($ca92951fe17fd102$var$C));
    },
    setThemeConfig (e) {
        const { themeMode: t, themeVariables: s } = e;
        t && ($ca92951fe17fd102$var$C.themeMode = t), s && ($ca92951fe17fd102$var$C.themeVariables = $ca92951fe17fd102$var$Y({}, s));
    }
}, $ca92951fe17fd102$var$g = (0, $lDt57.proxy)({
    open: !1,
    message: "",
    variant: "success"
}), $ca92951fe17fd102$export$49bec3d5b199c07 = {
    state: $ca92951fe17fd102$var$g,
    subscribe (e) {
        return (0, $lDt57.subscribe)($ca92951fe17fd102$var$g, ()=>e($ca92951fe17fd102$var$g));
    },
    openToast (e, t) {
        $ca92951fe17fd102$var$g.open = !0, $ca92951fe17fd102$var$g.message = e, $ca92951fe17fd102$var$g.variant = t;
    },
    closeToast () {
        $ca92951fe17fd102$var$g.open = !1;
    }
};

});
parcelRequire.register("lDt57", function(module, exports) {

$parcel$export(module.exports, "proxy", () => $fc03cc7843f50881$export$923f96dd5afa9ce6, (v) => $fc03cc7843f50881$export$923f96dd5afa9ce6 = v);
$parcel$export(module.exports, "snapshot", () => $fc03cc7843f50881$export$b8801ea43165ed7d, (v) => $fc03cc7843f50881$export$b8801ea43165ed7d = v);
$parcel$export(module.exports, "subscribe", () => $fc03cc7843f50881$export$ec068583843480e7, (v) => $fc03cc7843f50881$export$ec068583843480e7 = v);
var $fc03cc7843f50881$export$c506eb22e615ba4a;
var $fc03cc7843f50881$export$923f96dd5afa9ce6;
var $fc03cc7843f50881$export$eff4d24c3ff7876e;
var $fc03cc7843f50881$export$b8801ea43165ed7d;
var $fc03cc7843f50881$export$ec068583843480e7;
var $fc03cc7843f50881$export$e7b04d37d9502758;
"use strict";

var $fkrbD = parcelRequire("fkrbD");
var $fc03cc7843f50881$var$isObject = function isObject(x) {
    return typeof x === "object" && x !== null;
};
var $fc03cc7843f50881$var$proxyStateMap = new WeakMap();
var $fc03cc7843f50881$var$refSet = new WeakSet();
var $fc03cc7843f50881$var$buildProxyFunction = function buildProxyFunction(objectIs, newProxy, canProxy, defaultHandlePromise, snapCache, createSnapshot, proxyCache, versionHolder, _proxyFunction) {
    if (objectIs === void 0) objectIs = Object.is;
    if (newProxy === void 0) newProxy = function newProxy(target, handler) {
        return new Proxy(target, handler);
    };
    if (canProxy === void 0) canProxy = function canProxy(x) {
        return $fc03cc7843f50881$var$isObject(x) && !$fc03cc7843f50881$var$refSet.has(x) && (Array.isArray(x) || !(Symbol.iterator in x)) && !(x instanceof WeakMap) && !(x instanceof WeakSet) && !(x instanceof Error) && !(x instanceof Number) && !(x instanceof Date) && !(x instanceof String) && !(x instanceof RegExp) && !(x instanceof ArrayBuffer);
    };
    if (defaultHandlePromise === void 0) defaultHandlePromise = function defaultHandlePromise(promise) {
        switch(promise.status){
            case "fulfilled":
                return promise.value;
            case "rejected":
                throw promise.reason;
            default:
                throw promise;
        }
    };
    if (snapCache === void 0) snapCache = new WeakMap();
    if (createSnapshot === void 0) createSnapshot = function(_createSnapshot) {
        function createSnapshot(_x, _x2, _x3) {
            return _createSnapshot.apply(this, arguments);
        }
        createSnapshot.toString = function() {
            return _createSnapshot.toString();
        };
        return createSnapshot;
    }(function(target, version, handlePromise) {
        if (handlePromise === void 0) handlePromise = defaultHandlePromise;
        var cache = snapCache.get(target);
        if ((cache == null ? void 0 : cache[0]) === version) return cache[1];
        var snap = Array.isArray(target) ? [] : Object.create(Object.getPrototypeOf(target));
        $fkrbD.markToTrack(snap, true);
        snapCache.set(target, [
            version,
            snap
        ]);
        Reflect.ownKeys(target).forEach(function(key) {
            if (Object.getOwnPropertyDescriptor(snap, key)) return;
            var value = Reflect.get(target, key);
            var desc = {
                value: value,
                enumerable: true,
                configurable: true
            };
            if ($fc03cc7843f50881$var$refSet.has(value)) $fkrbD.markToTrack(value, false);
            else if (value instanceof Promise) {
                delete desc.value;
                desc.get = function() {
                    return handlePromise(value);
                };
            } else if ($fc03cc7843f50881$var$proxyStateMap.has(value)) {
                var _ref = $fc03cc7843f50881$var$proxyStateMap.get(value), _target = _ref[0], _ensureVersion = _ref[1];
                desc.value = createSnapshot(_target, _ensureVersion(), handlePromise);
            }
            Object.defineProperty(snap, key, desc);
        });
        return Object.preventExtensions(snap);
    });
    if (proxyCache === void 0) proxyCache = new WeakMap();
    if (versionHolder === void 0) versionHolder = [
        1,
        1
    ];
    if (_proxyFunction === void 0) _proxyFunction = function proxyFunction(initialObject) {
        if (!$fc03cc7843f50881$var$isObject(initialObject)) throw new Error("object required");
        var found = proxyCache.get(initialObject);
        if (found) return found;
        var version = versionHolder[0];
        var listeners = new Set();
        var notifyUpdate = function notifyUpdate(op, nextVersion) {
            if (nextVersion === void 0) nextVersion = ++versionHolder[0];
            if (version !== nextVersion) {
                version = nextVersion;
                listeners.forEach(function(listener) {
                    return listener(op, nextVersion);
                });
            }
        };
        var checkVersion = versionHolder[1];
        var ensureVersion = function ensureVersion(nextCheckVersion) {
            if (nextCheckVersion === void 0) nextCheckVersion = ++versionHolder[1];
            if (checkVersion !== nextCheckVersion && !listeners.size) {
                checkVersion = nextCheckVersion;
                propProxyStates.forEach(function(_ref2) {
                    var propProxyState = _ref2[0];
                    var propVersion = propProxyState[1](nextCheckVersion);
                    if (propVersion > version) version = propVersion;
                });
            }
            return version;
        };
        var createPropListener = function createPropListener(prop) {
            return function(op, nextVersion) {
                var newOp = [].concat(op);
                newOp[1] = [
                    prop
                ].concat(newOp[1]);
                notifyUpdate(newOp, nextVersion);
            };
        };
        var propProxyStates = new Map();
        var addPropListener = function addPropListener(prop, propProxyState) {
            if (listeners.size) {
                var remove = propProxyState[3](createPropListener(prop));
                propProxyStates.set(prop, [
                    propProxyState,
                    remove
                ]);
            } else propProxyStates.set(prop, [
                propProxyState
            ]);
        };
        var removePropListener = function removePropListener(prop) {
            var entry = propProxyStates.get(prop);
            if (entry) {
                var _entry$;
                propProxyStates.delete(prop);
                (_entry$ = entry[1]) == null || _entry$.call(entry);
            }
        };
        var addListener = function addListener(listener) {
            listeners.add(listener);
            if (listeners.size === 1) propProxyStates.forEach(function(_ref3, prop) {
                var propProxyState = _ref3[0], prevRemove = _ref3[1];
                var remove = propProxyState[3](createPropListener(prop));
                propProxyStates.set(prop, [
                    propProxyState,
                    remove
                ]);
            });
            var removeListener = function removeListener() {
                listeners.delete(listener);
                if (listeners.size === 0) propProxyStates.forEach(function(_ref4, prop) {
                    var propProxyState = _ref4[0], remove = _ref4[1];
                    if (remove) {
                        remove();
                        propProxyStates.set(prop, [
                            propProxyState
                        ]);
                    }
                });
            };
            return removeListener;
        };
        var baseObject = Array.isArray(initialObject) ? [] : Object.create(Object.getPrototypeOf(initialObject));
        var handler = {
            deleteProperty: function deleteProperty(target, prop) {
                var prevValue = Reflect.get(target, prop);
                removePropListener(prop);
                var deleted = Reflect.deleteProperty(target, prop);
                if (deleted) notifyUpdate([
                    "delete",
                    [
                        prop
                    ],
                    prevValue
                ]);
                return deleted;
            },
            set: function set(target, prop, value, receiver) {
                var hasPrevValue = Reflect.has(target, prop);
                var prevValue = Reflect.get(target, prop, receiver);
                if (hasPrevValue && (objectIs(prevValue, value) || proxyCache.has(value) && objectIs(prevValue, proxyCache.get(value)))) return true;
                removePropListener(prop);
                if ($fc03cc7843f50881$var$isObject(value)) value = $fkrbD.getUntracked(value) || value;
                var nextValue = value;
                if (value instanceof Promise) value.then(function(v) {
                    value.status = "fulfilled";
                    value.value = v;
                    notifyUpdate([
                        "resolve",
                        [
                            prop
                        ],
                        v
                    ]);
                }).catch(function(e) {
                    value.status = "rejected";
                    value.reason = e;
                    notifyUpdate([
                        "reject",
                        [
                            prop
                        ],
                        e
                    ]);
                });
                else {
                    if (!$fc03cc7843f50881$var$proxyStateMap.has(value) && canProxy(value)) nextValue = _proxyFunction(value);
                    var childProxyState = !$fc03cc7843f50881$var$refSet.has(nextValue) && $fc03cc7843f50881$var$proxyStateMap.get(nextValue);
                    if (childProxyState) addPropListener(prop, childProxyState);
                }
                Reflect.set(target, prop, nextValue, receiver);
                notifyUpdate([
                    "set",
                    [
                        prop
                    ],
                    value,
                    prevValue
                ]);
                return true;
            }
        };
        var proxyObject = newProxy(baseObject, handler);
        proxyCache.set(initialObject, proxyObject);
        var proxyState = [
            baseObject,
            ensureVersion,
            createSnapshot,
            addListener
        ];
        $fc03cc7843f50881$var$proxyStateMap.set(proxyObject, proxyState);
        Reflect.ownKeys(initialObject).forEach(function(key) {
            var desc = Object.getOwnPropertyDescriptor(initialObject, key);
            if ("value" in desc) {
                proxyObject[key] = initialObject[key];
                delete desc.value;
                delete desc.writable;
            }
            Object.defineProperty(baseObject, key, desc);
        });
        return proxyObject;
    };
    return [
        _proxyFunction,
        $fc03cc7843f50881$var$proxyStateMap,
        $fc03cc7843f50881$var$refSet,
        objectIs,
        newProxy,
        canProxy,
        defaultHandlePromise,
        snapCache,
        createSnapshot,
        proxyCache,
        versionHolder
    ];
};
var $fc03cc7843f50881$var$_buildProxyFunction = $fc03cc7843f50881$var$buildProxyFunction(), $fc03cc7843f50881$var$defaultProxyFunction = $fc03cc7843f50881$var$_buildProxyFunction[0];
function $fc03cc7843f50881$var$proxy(initialObject) {
    if (initialObject === void 0) initialObject = {};
    return $fc03cc7843f50881$var$defaultProxyFunction(initialObject);
}
function $fc03cc7843f50881$var$getVersion(proxyObject) {
    var proxyState = $fc03cc7843f50881$var$proxyStateMap.get(proxyObject);
    return proxyState == null ? void 0 : proxyState[1]();
}
function $fc03cc7843f50881$var$subscribe(proxyObject, callback, notifyInSync) {
    var proxyState = $fc03cc7843f50881$var$proxyStateMap.get(proxyObject);
    var promise;
    var ops = [];
    var addListener = proxyState[3];
    var isListenerActive = false;
    var listener = function listener(op) {
        ops.push(op);
        if (notifyInSync) {
            callback(ops.splice(0));
            return;
        }
        if (!promise) promise = Promise.resolve().then(function() {
            promise = undefined;
            if (isListenerActive) callback(ops.splice(0));
        });
    };
    var removeListener = addListener(listener);
    isListenerActive = true;
    return function() {
        isListenerActive = false;
        removeListener();
    };
}
function $fc03cc7843f50881$var$snapshot(proxyObject, handlePromise) {
    var proxyState = $fc03cc7843f50881$var$proxyStateMap.get(proxyObject);
    var _ref5 = proxyState, target = _ref5[0], ensureVersion = _ref5[1], createSnapshot = _ref5[2];
    return createSnapshot(target, ensureVersion(), handlePromise);
}
function $fc03cc7843f50881$var$ref(obj) {
    $fc03cc7843f50881$var$refSet.add(obj);
    return obj;
}
var $fc03cc7843f50881$var$unstable_buildProxyFunction = $fc03cc7843f50881$var$buildProxyFunction;
$fc03cc7843f50881$export$c506eb22e615ba4a = $fc03cc7843f50881$var$getVersion;
$fc03cc7843f50881$export$923f96dd5afa9ce6 = $fc03cc7843f50881$var$proxy;
$fc03cc7843f50881$export$eff4d24c3ff7876e = $fc03cc7843f50881$var$ref;
$fc03cc7843f50881$export$b8801ea43165ed7d = $fc03cc7843f50881$var$snapshot;
$fc03cc7843f50881$export$ec068583843480e7 = $fc03cc7843f50881$var$subscribe;
$fc03cc7843f50881$export$e7b04d37d9502758 = $fc03cc7843f50881$var$unstable_buildProxyFunction;

});
parcelRequire.register("fkrbD", function(module, exports) {

$parcel$export(module.exports, "getUntracked", () => $b28dcff9705b9efe$export$80d2cee7ee556e99);
$parcel$export(module.exports, "markToTrack", () => $b28dcff9705b9efe$export$2c8383c890e26a1c);
const $b28dcff9705b9efe$var$e = Symbol(), $b28dcff9705b9efe$var$t = Symbol(), $b28dcff9705b9efe$var$r = "a", $b28dcff9705b9efe$var$n = "w";
let $b28dcff9705b9efe$var$o = (e, t)=>new Proxy(e, t);
const $b28dcff9705b9efe$var$s = Object.getPrototypeOf, $b28dcff9705b9efe$var$c = new WeakMap, $b28dcff9705b9efe$var$l = (e)=>e && ($b28dcff9705b9efe$var$c.has(e) ? $b28dcff9705b9efe$var$c.get(e) : $b28dcff9705b9efe$var$s(e) === Object.prototype || $b28dcff9705b9efe$var$s(e) === Array.prototype), $b28dcff9705b9efe$var$f = (e)=>"object" == typeof e && null !== e, $b28dcff9705b9efe$var$i = (e)=>{
    if (Array.isArray(e)) return Array.from(e);
    const t = Object.getOwnPropertyDescriptors(e);
    return Object.values(t).forEach((e)=>{
        e.configurable = !0;
    }), Object.create($b28dcff9705b9efe$var$s(e), t);
}, $b28dcff9705b9efe$var$u = (e)=>e[$b28dcff9705b9efe$var$t] || e, $b28dcff9705b9efe$export$7865d0c7f908de6b = (s, c, f, p)=>{
    if (!$b28dcff9705b9efe$var$l(s)) return s;
    let g = p && p.get(s);
    if (!g) {
        const e = $b28dcff9705b9efe$var$u(s);
        g = ((e)=>Object.values(Object.getOwnPropertyDescriptors(e)).some((e)=>!e.configurable && !e.writable))(e) ? [
            e,
            $b28dcff9705b9efe$var$i(e)
        ] : [
            e
        ], null == p || p.set(s, g);
    }
    const [y, h] = g;
    let w = f && f.get(y);
    return w && w[1].f === !!h || (w = ((o, s)=>{
        const c = {
            f: s
        };
        let l = !1;
        const f = (e, t)=>{
            if (!l) {
                let s = c[$b28dcff9705b9efe$var$r].get(o);
                if (s || (s = {}, c[$b28dcff9705b9efe$var$r].set(o, s)), e === $b28dcff9705b9efe$var$n) s[$b28dcff9705b9efe$var$n] = !0;
                else {
                    let r = s[e];
                    r || (r = new Set, s[e] = r), r.add(t);
                }
            }
        }, i = {
            get: (e, n)=>n === $b28dcff9705b9efe$var$t ? o : (f("k", n), $b28dcff9705b9efe$export$7865d0c7f908de6b(Reflect.get(e, n), c[$b28dcff9705b9efe$var$r], c.c, c.t)),
            has: (t, n)=>n === $b28dcff9705b9efe$var$e ? (l = !0, c[$b28dcff9705b9efe$var$r].delete(o), !0) : (f("h", n), Reflect.has(t, n)),
            getOwnPropertyDescriptor: (e, t)=>(f("o", t), Reflect.getOwnPropertyDescriptor(e, t)),
            ownKeys: (e)=>(f($b28dcff9705b9efe$var$n), Reflect.ownKeys(e))
        };
        return s && (i.set = i.deleteProperty = ()=>!1), [
            i,
            c
        ];
    })(y, !!h), w[1].p = $b28dcff9705b9efe$var$o(h || y, w[0]), f && f.set(y, w)), w[1][$b28dcff9705b9efe$var$r] = c, w[1].c = f, w[1].t = p, w[1].p;
}, $b28dcff9705b9efe$export$3a85b3f4caf02b6f = (e, t, r, o)=>{
    if (Object.is(e, t)) return !1;
    if (!$b28dcff9705b9efe$var$f(e) || !$b28dcff9705b9efe$var$f(t)) return !0;
    const s = r.get($b28dcff9705b9efe$var$u(e));
    if (!s) return !0;
    if (o) {
        const r = o.get(e);
        if (r && r.n === t) return r.g;
        o.set(e, {
            n: t,
            g: !1
        });
    }
    let c = null;
    try {
        for (const r of s.h || [])if (c = Reflect.has(e, r) !== Reflect.has(t, r), c) return c;
        if (!0 === s[$b28dcff9705b9efe$var$n]) {
            if (c = ((e, t)=>{
                const r = Reflect.ownKeys(e), n = Reflect.ownKeys(t);
                return r.length !== n.length || r.some((e, t)=>e !== n[t]);
            })(e, t), c) return c;
        } else for (const r of s.o || [])if (c = !!Reflect.getOwnPropertyDescriptor(e, r) != !!Reflect.getOwnPropertyDescriptor(t, r), c) return c;
        for (const n of s.k || [])if (c = $b28dcff9705b9efe$export$3a85b3f4caf02b6f(e[n], t[n], r, o), c) return c;
        return null === c && (c = !0), c;
    } finally{
        o && o.set(e, {
            n: t,
            g: c
        });
    }
}, $b28dcff9705b9efe$export$badc26589cf7bb38 = (t)=>!!$b28dcff9705b9efe$var$l(t) && $b28dcff9705b9efe$var$e in t, $b28dcff9705b9efe$export$80d2cee7ee556e99 = (e)=>$b28dcff9705b9efe$var$l(e) && e[$b28dcff9705b9efe$var$t] || null, $b28dcff9705b9efe$export$2c8383c890e26a1c = (e, t = !0)=>{
    $b28dcff9705b9efe$var$c.set(e, t);
}, $b28dcff9705b9efe$export$10e85fc10e680a16 = (e, t, r)=>{
    const o = [], s = new WeakSet, c = (e, l)=>{
        if (s.has(e)) return;
        $b28dcff9705b9efe$var$f(e) && s.add(e);
        const i = $b28dcff9705b9efe$var$f(e) && t.get($b28dcff9705b9efe$var$u(e));
        if (i) {
            var a, p;
            if (null == (a = i.h) || a.forEach((e)=>{
                const t = `:has(${String(e)})`;
                o.push(l ? [
                    ...l,
                    t
                ] : [
                    t
                ]);
            }), !0 === i[$b28dcff9705b9efe$var$n]) {
                const e = ":ownKeys";
                o.push(l ? [
                    ...l,
                    e
                ] : [
                    e
                ]);
            } else {
                var g;
                null == (g = i.o) || g.forEach((e)=>{
                    const t = `:hasOwn(${String(e)})`;
                    o.push(l ? [
                        ...l,
                        t
                    ] : [
                        t
                    ]);
                });
            }
            null == (p = i.k) || p.forEach((t)=>{
                r && !("value" in (Object.getOwnPropertyDescriptor(e, t) || {})) || c(e[t], l ? [
                    ...l,
                    t
                ] : [
                    t
                ]);
            });
        } else l && o.push(l);
    };
    return c(e), o;
}, $b28dcff9705b9efe$export$9b4d5450dbd8e67e = (e)=>{
    $b28dcff9705b9efe$var$o = e;
};

});



parcelRequire.register("aIeTu", function(module, exports) {

module.exports = import("./" + (parcelRequire("27Lyk")).resolve("cGIh0")).then(()=>parcelRequire("k9DFq"));

});



//# sourceMappingURL=dist.27d8b843.js.map
